import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  questionGroup: css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,
  answerGroup: css`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;

    @media (max-width: 480px) {
      gap: 12px;
    }

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
  `,
} satisfies Styles<void>;

export const useToggleQuestionStyles = withStyles(styles);
